module.exports = __webpack_public_path__ + "static/media/n04.ec034939.jpg";